import { FunctionComponent } from 'react';
import { PerspectiveCamera } from '@react-three/drei';
import { RoundedCornerBox } from '@/components/RoundedCornerBox';
import { useResponsive } from '@/hooks/useResponsive';

export const Screen: FunctionComponent = ({ children }) => {
    const { isMobileSize, scale, contentBounds } = useResponsive();
    return (
        <>
            <PerspectiveCamera position={[0, 0, 5]} near={0.1} far={1000} fov={75} makeDefault />
            <group scale={scale}>{children}</group>
            {!isMobileSize && (
                <RoundedCornerBox
                    left={contentBounds.left}
                    right={contentBounds.right}
                    top={contentBounds.top}
                    bottom={contentBounds.bottom}
                    lineWidth={4}
                />
            )}
        </>
    );
};
